import { EXPERT_MATERIAL_TYPE } from '~/admin/shared/lib/materialType';

export const TYPES = [
  {
    value: 'news',
    content: 'Новость',
  },
  {
    value: 'analytics',
    content: 'Аналитика',
  },
  {
    value: 'new_object',
    content: 'Новый строящийся объект',
  },
  {
    value: EXPERT_MATERIAL_TYPE,
    content: 'Мнение экспертов',
  },
];
